import React from 'react';
import { Card, Typography, Empty } from 'antd';

const { Title } = Typography;

const RemoteAccess: React.FC = () => {
  return (
    <div style={{ padding: 24, background: '#f0f2f5', minHeight: 'calc(100vh - 64px)' }}>
      <Title level={2}>Remote Access</Title>
      <Card>
        <Empty description="Remote access feature coming soon" />
      </Card>
    </div>
  );
};

export default RemoteAccess;
